import { a as M, e as F, b as C, B as Me } from "./abstract-base-xBS_db8B.js";
import { m as Fe } from "./lifecycle-decorators-CUsT9aHq.js";
import { B as Ce } from "./beacon-primitive-ChVMWFlW.js";
import { b as Ae } from "./query-assigned-DFUTWPNn.js";
import { i as Ie } from "./utils-BSj5iT7c.js";
(function() {
  (function(f) {
    const l = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ new WeakMap(), W = /* @__PURE__ */ new WeakMap(), $ = /* @__PURE__ */ new WeakMap(), U = /* @__PURE__ */ new WeakMap(), z = /* @__PURE__ */ new WeakMap(), I = /* @__PURE__ */ new WeakMap(), k = {
      ariaAtomic: "aria-atomic",
      ariaAutoComplete: "aria-autocomplete",
      ariaBusy: "aria-busy",
      ariaChecked: "aria-checked",
      ariaColCount: "aria-colcount",
      ariaColIndex: "aria-colindex",
      ariaColIndexText: "aria-colindextext",
      ariaColSpan: "aria-colspan",
      ariaCurrent: "aria-current",
      ariaDescription: "aria-description",
      ariaDisabled: "aria-disabled",
      ariaExpanded: "aria-expanded",
      ariaHasPopup: "aria-haspopup",
      ariaHidden: "aria-hidden",
      ariaInvalid: "aria-invalid",
      ariaKeyShortcuts: "aria-keyshortcuts",
      ariaLabel: "aria-label",
      ariaLevel: "aria-level",
      ariaLive: "aria-live",
      ariaModal: "aria-modal",
      ariaMultiLine: "aria-multiline",
      ariaMultiSelectable: "aria-multiselectable",
      ariaOrientation: "aria-orientation",
      ariaPlaceholder: "aria-placeholder",
      ariaPosInSet: "aria-posinset",
      ariaPressed: "aria-pressed",
      ariaReadOnly: "aria-readonly",
      ariaRelevant: "aria-relevant",
      ariaRequired: "aria-required",
      ariaRoleDescription: "aria-roledescription",
      ariaRowCount: "aria-rowcount",
      ariaRowIndex: "aria-rowindex",
      ariaRowIndexText: "aria-rowindextext",
      ariaRowSpan: "aria-rowspan",
      ariaSelected: "aria-selected",
      ariaSetSize: "aria-setsize",
      ariaSort: "aria-sort",
      ariaValueMax: "aria-valuemax",
      ariaValueMin: "aria-valuemin",
      ariaValueNow: "aria-valuenow",
      ariaValueText: "aria-valuetext",
      role: "role"
    }, re = (t, e) => {
      for (let a in k) {
        e[a] = null;
        let n = null;
        const i = k[a];
        Object.defineProperty(e, a, {
          get() {
            return n;
          },
          set(o) {
            n = o, t.isConnected ? t.setAttribute(i, o) : A.set(t, e);
          }
        });
      }
    };
    function j(t) {
      const e = r.get(t), { form: a } = e;
      X(t, a, e), J(t, e.labels);
    }
    const K = (t, e = !1) => {
      const a = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
        acceptNode(o) {
          return r.has(o) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      let n = a.nextNode();
      const i = !e || t.disabled;
      for (; n; )
        n.formDisabledCallback && i && P(n, t.disabled), n = a.nextNode();
    }, q = { attributes: !0, attributeFilter: ["disabled", "name"] }, S = x() ? new MutationObserver((t) => {
      for (const e of t) {
        const a = e.target;
        if (e.attributeName === "disabled" && (a.constructor.formAssociated ? P(a, a.hasAttribute("disabled")) : a.localName === "fieldset" && K(a)), e.attributeName === "name" && a.constructor.formAssociated) {
          const n = r.get(a), i = H.get(a);
          n.setFormValue(i);
        }
      }
    }) : {};
    function O(t) {
      t.forEach((e) => {
        const { addedNodes: a, removedNodes: n } = e, i = Array.from(a), o = Array.from(n);
        i.forEach((s) => {
          var m;
          if (r.has(s) && s.constructor.formAssociated && j(s), A.has(s)) {
            const u = A.get(s);
            Object.keys(k).filter((p) => u[p] !== null).forEach((p) => {
              s.setAttribute(k[p], u[p]);
            }), A.delete(s);
          }
          if (I.has(s)) {
            const u = I.get(s);
            s.setAttribute("internals-valid", u.validity.valid.toString()), s.setAttribute("internals-invalid", (!u.validity.valid).toString()), s.setAttribute("aria-invalid", (!u.validity.valid).toString()), I.delete(s);
          }
          if (s.localName === "form") {
            const u = v.get(s), g = document.createTreeWalker(s, NodeFilter.SHOW_ELEMENT, {
              acceptNode(D) {
                return r.has(D) && D.constructor.formAssociated && !(u && u.has(D)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
              }
            });
            let p = g.nextNode();
            for (; p; )
              j(p), p = g.nextNode();
          }
          s.localName === "fieldset" && ((m = S.observe) === null || m === void 0 || m.call(S, s, q), K(s, !0));
        }), o.forEach((s) => {
          const m = r.get(s);
          m && d.get(m) && G(m), N.has(s) && N.get(s).disconnect();
        });
      });
    }
    function se(t) {
      t.forEach((e) => {
        const { removedNodes: a } = e;
        a.forEach((n) => {
          const i = U.get(e.target);
          r.has(n) && Z(n), i.disconnect();
        });
      });
    }
    const le = (t) => {
      var e, a;
      const n = new MutationObserver(se);
      !((e = window == null ? void 0 : window.ShadyDOM) === null || e === void 0) && e.inUse && t.mode && t.host && (t = t.host), (a = n.observe) === null || a === void 0 || a.call(n, t, { childList: !0 }), U.set(t, n);
    };
    x() && new MutationObserver(O);
    const L = {
      childList: !0,
      subtree: !0
    }, P = (t, e) => {
      t.toggleAttribute("internals-disabled", e), e ? t.setAttribute("aria-disabled", "true") : t.removeAttribute("aria-disabled"), t.formDisabledCallback && t.formDisabledCallback.apply(t, [e]);
    }, G = (t) => {
      d.get(t).forEach((a) => {
        a.remove();
      }), d.set(t, []);
    }, Q = (t, e) => {
      const a = document.createElement("input");
      return a.type = "hidden", a.name = t.getAttribute("name"), t.after(a), d.get(e).push(a), a;
    }, ce = (t, e) => {
      var a;
      d.set(e, []), (a = S.observe) === null || a === void 0 || a.call(S, t, q);
    }, J = (t, e) => {
      if (e.length) {
        Array.from(e).forEach((n) => n.addEventListener("click", t.click.bind(t)));
        let a = e[0].id;
        e[0].id || (a = `${e[0].htmlFor}_Label`, e[0].id = a), t.setAttribute("aria-labelledby", a);
      }
    }, T = (t) => {
      const e = Array.from(t.elements).filter((o) => !o.tagName.includes("-") && o.validity).map((o) => o.validity.valid), a = v.get(t) || [], n = Array.from(a).filter((o) => o.isConnected).map((o) => r.get(o).validity.valid), i = [...e, ...n].includes(!1);
      t.toggleAttribute("internals-invalid", i), t.toggleAttribute("internals-valid", !i);
    }, de = (t) => {
      T(V(t.target));
    }, ue = (t) => {
      T(V(t.target));
    }, me = (t) => {
      const e = ["button[type=submit]", "input[type=submit]", "button:not([type])"].map((a) => `${a}:not([disabled])`).map((a) => `${a}:not([form])${t.id ? `,${a}[form='${t.id}']` : ""}`).join(",");
      t.addEventListener("click", (a) => {
        if (a.target.closest(e)) {
          const i = v.get(t);
          if (t.noValidate)
            return;
          i.size && Array.from(i).reverse().map((m) => r.get(m).reportValidity()).includes(!1) && a.preventDefault();
        }
      });
    }, fe = (t) => {
      const e = v.get(t.target);
      e && e.size && e.forEach((a) => {
        a.constructor.formAssociated && a.formResetCallback && a.formResetCallback.apply(a);
      });
    }, X = (t, e, a) => {
      if (e) {
        const n = v.get(e);
        if (n)
          n.add(t);
        else {
          const i = /* @__PURE__ */ new Set();
          i.add(t), v.set(e, i), me(e), e.addEventListener("reset", fe), e.addEventListener("input", de), e.addEventListener("change", ue);
        }
        b.set(e, { ref: t, internals: a }), t.constructor.formAssociated && t.formAssociatedCallback && setTimeout(() => {
          t.formAssociatedCallback.apply(t, [e]);
        }, 0), T(e);
      }
    }, V = (t) => {
      let e = t.parentNode;
      return e && e.tagName !== "FORM" && (e = V(e)), e;
    }, y = (t, e, a = DOMException) => {
      if (!t.constructor.formAssociated)
        throw new a(e);
    }, Y = (t, e, a) => {
      const n = v.get(t);
      return n && n.size && n.forEach((i) => {
        r.get(i)[a]() || (e = !1);
      }), e;
    }, Z = (t) => {
      if (t.constructor.formAssociated) {
        const e = r.get(t), { labels: a, form: n } = e;
        J(t, a), X(t, n, e);
      }
    };
    function x() {
      return typeof MutationObserver < "u";
    }
    class he {
      constructor() {
        this.badInput = !1, this.customError = !1, this.patternMismatch = !1, this.rangeOverflow = !1, this.rangeUnderflow = !1, this.stepMismatch = !1, this.tooLong = !1, this.tooShort = !1, this.typeMismatch = !1, this.valid = !0, this.valueMissing = !1, Object.seal(this);
      }
    }
    const pe = (t) => (t.badInput = !1, t.customError = !1, t.patternMismatch = !1, t.rangeOverflow = !1, t.rangeUnderflow = !1, t.stepMismatch = !1, t.tooLong = !1, t.tooShort = !1, t.typeMismatch = !1, t.valid = !0, t.valueMissing = !1, t), ye = (t, e, a) => (t.valid = ge(e), Object.keys(e).forEach((n) => t[n] = e[n]), a && T(a), t), ge = (t) => {
      let e = !0;
      for (let a in t)
        a !== "valid" && t[a] !== !1 && (e = !1);
      return e;
    }, B = /* @__PURE__ */ new WeakMap();
    function ee(t, e) {
      t.toggleAttribute(e, !0), t.part && t.part.add(e);
    }
    class _ extends Set {
      static get isPolyfilled() {
        return !0;
      }
      constructor(e) {
        if (super(), !e || !e.tagName || e.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        B.set(this, e);
      }
      add(e) {
        if (!/^--/.test(e) || typeof e != "string")
          throw new DOMException(`Failed to execute 'add' on 'CustomStateSet': The specified value ${e} must start with '--'.`);
        const a = super.add(e), n = B.get(this), i = `state${e}`;
        return n.isConnected ? ee(n, i) : setTimeout(() => {
          ee(n, i);
        }), a;
      }
      clear() {
        for (let [e] of this.entries())
          this.delete(e);
        super.clear();
      }
      delete(e) {
        const a = super.delete(e), n = B.get(this);
        return n.isConnected ? (n.toggleAttribute(`state${e}`, !1), n.part && n.part.remove(`state${e}`)) : setTimeout(() => {
          n.toggleAttribute(`state${e}`, !1), n.part && n.part.remove(`state${e}`);
        }), a;
      }
    }
    function te(t, e, a, n) {
      if (a === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
      if (typeof e == "function" ? t !== e || !n : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
      return a === "m" ? n : a === "a" ? n.call(t) : n ? n.value : e.get(t);
    }
    function be(t, e, a, n, i) {
      if (typeof e == "function" ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
      return e.set(t, a), a;
    }
    var E;
    class ve {
      constructor(e) {
        E.set(this, void 0), be(this, E, e);
        for (let a = 0; a < e.length; a++) {
          let n = e[a];
          this[a] = n, n.hasAttribute("name") && (this[n.getAttribute("name")] = n);
        }
        Object.freeze(this);
      }
      get length() {
        return te(this, E, "f").length;
      }
      [(E = /* @__PURE__ */ new WeakMap(), Symbol.iterator)]() {
        return te(this, E, "f")[Symbol.iterator]();
      }
      item(e) {
        return this[e] == null ? null : this[e];
      }
      namedItem(e) {
        return this[e] == null ? null : this[e];
      }
    }
    function we() {
      const t = HTMLFormElement.prototype.checkValidity;
      HTMLFormElement.prototype.checkValidity = a;
      const e = HTMLFormElement.prototype.reportValidity;
      HTMLFormElement.prototype.reportValidity = n;
      function a(...o) {
        let s = t.apply(this, o);
        return Y(this, s, "checkValidity");
      }
      function n(...o) {
        let s = e.apply(this, o);
        return Y(this, s, "reportValidity");
      }
      const { get: i } = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "elements");
      Object.defineProperty(HTMLFormElement.prototype, "elements", {
        get(...o) {
          const s = i.call(this, ...o), m = Array.from(v.get(this) || []);
          if (m.length === 0)
            return s;
          const u = Array.from(s).concat(m).sort((g, p) => g.compareDocumentPosition ? g.compareDocumentPosition(p) & 2 ? 1 : -1 : 0);
          return new ve(u);
        }
      });
    }
    class ae {
      static get isPolyfilled() {
        return !0;
      }
      constructor(e) {
        if (!e || !e.tagName || e.tagName.indexOf("-") === -1)
          throw new TypeError("Illegal constructor");
        const a = e.getRootNode(), n = new he();
        this.states = new _(e), l.set(this, e), c.set(this, n), r.set(e, this), re(e, this), ce(e, this), Object.seal(this), a instanceof DocumentFragment && le(a);
      }
      checkValidity() {
        const e = l.get(this);
        if (y(e, "Failed to execute 'checkValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const a = c.get(this);
        if (!a.valid) {
          const n = new Event("invalid", {
            bubbles: !1,
            cancelable: !0,
            composed: !1
          });
          e.dispatchEvent(n);
        }
        return a.valid;
      }
      get form() {
        const e = l.get(this);
        y(e, "Failed to read the 'form' property from 'ElementInternals': The target element is not a form-associated custom element.");
        let a;
        return e.constructor.formAssociated === !0 && (a = V(e)), a;
      }
      get labels() {
        const e = l.get(this);
        y(e, "Failed to read the 'labels' property from 'ElementInternals': The target element is not a form-associated custom element.");
        const a = e.getAttribute("id"), n = e.getRootNode();
        return n && a ? n.querySelectorAll(`[for="${a}"]`) : [];
      }
      reportValidity() {
        const e = l.get(this);
        if (y(e, "Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate)
          return !0;
        const a = this.checkValidity(), n = $.get(this);
        if (n && !e.constructor.formAssociated)
          throw new DOMException("Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element.");
        return !a && n && (e.focus(), n.focus()), a;
      }
      setFormValue(e) {
        const a = l.get(this);
        if (y(a, "Failed to execute 'setFormValue' on 'ElementInternals': The target element is not a form-associated custom element."), G(this), e != null && !(e instanceof FormData)) {
          if (a.getAttribute("name")) {
            const n = Q(a, this);
            n.value = e;
          }
        } else e != null && e instanceof FormData && Array.from(e).reverse().forEach(([n, i]) => {
          if (typeof i == "string") {
            const o = Q(a, this);
            o.name = n, o.value = i;
          }
        });
        H.set(a, e);
      }
      setValidity(e, a, n) {
        const i = l.get(this);
        if (y(i, "Failed to execute 'setValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !e)
          throw new TypeError("Failed to execute 'setValidity' on 'ElementInternals': 1 argument required, but only 0 present.");
        $.set(this, n);
        const o = c.get(this), s = {};
        for (const g in e)
          s[g] = e[g];
        Object.keys(s).length === 0 && pe(o);
        const m = Object.assign(Object.assign({}, o), s);
        delete m.valid;
        const { valid: u } = ye(o, m, this.form);
        if (!u && !a)
          throw new DOMException("Failed to execute 'setValidity' on 'ElementInternals': The second argument should not be empty if one or more flags in the first argument are true.");
        h.set(this, u ? "" : a), i.isConnected ? (i.toggleAttribute("internals-invalid", !u), i.toggleAttribute("internals-valid", u), i.setAttribute("aria-invalid", `${!u}`)) : I.set(i, this);
      }
      get shadowRoot() {
        const e = l.get(this), a = W.get(e);
        return a || null;
      }
      get validationMessage() {
        const e = l.get(this);
        return y(e, "Failed to read the 'validationMessage' property from 'ElementInternals': The target element is not a form-associated custom element."), h.get(this);
      }
      get validity() {
        const e = l.get(this);
        return y(e, "Failed to read the 'validity' property from 'ElementInternals': The target element is not a form-associated custom element."), c.get(this);
      }
      get willValidate() {
        const e = l.get(this);
        return y(e, "Failed to read the 'willValidate' property from 'ElementInternals': The target element is not a form-associated custom element."), !(e.disabled || e.hasAttribute("disabled") || e.hasAttribute("readonly"));
      }
    }
    function Ee() {
      if (typeof window > "u" || !window.ElementInternals || !HTMLElement.prototype.attachInternals)
        return !1;
      class t extends HTMLElement {
        constructor() {
          super(), this.internals = this.attachInternals();
        }
      }
      const e = `element-internals-feature-detection-${Math.random().toString(36).replace(/[^a-z]+/g, "")}`;
      customElements.define(e, t);
      const a = new t();
      return [
        "shadowRoot",
        "form",
        "willValidate",
        "validity",
        "validationMessage",
        "labels",
        "setFormValue",
        "setValidity",
        "checkValidity",
        "reportValidity"
      ].every((n) => n in a.internals);
    }
    let ne = !1, ie = !1;
    function R(t) {
      ie || (ie = !0, window.CustomStateSet = _, t && (HTMLElement.prototype.attachInternals = function(...e) {
        const a = t.call(this, e);
        return a.states = new _(this), a;
      }));
    }
    function oe(t = !0) {
      if (!ne) {
        if (ne = !0, typeof window < "u" && (window.ElementInternals = ae), typeof CustomElementRegistry < "u") {
          const e = CustomElementRegistry.prototype.define;
          CustomElementRegistry.prototype.define = function(a, n, i) {
            if (n.formAssociated) {
              const o = n.prototype.connectedCallback;
              n.prototype.connectedCallback = function() {
                z.has(this) || (z.set(this, !0), this.hasAttribute("disabled") && P(this, !0)), o != null && o.apply(this), Z(this);
              };
            }
            e.call(this, a, n, i);
          };
        }
        if (typeof HTMLElement < "u" && (HTMLElement.prototype.attachInternals = function() {
          if (this.tagName) {
            if (this.tagName.indexOf("-") === -1)
              throw new Error("Failed to execute 'attachInternals' on 'HTMLElement': Unable to attach ElementInternals to non-custom elements.");
          } else return {};
          if (r.has(this))
            throw new DOMException("DOMException: Failed to execute 'attachInternals' on 'HTMLElement': ElementInternals for the specified element was already attached.");
          return new ae(this);
        }), typeof Element < "u") {
          let e = function(...n) {
            const i = a.apply(this, n);
            if (W.set(this, i), x()) {
              const o = new MutationObserver(O);
              window.ShadyDOM ? o.observe(this, L) : o.observe(i, L), N.set(this, o);
            }
            return i;
          };
          const a = Element.prototype.attachShadow;
          Element.prototype.attachShadow = e;
        }
        x() && typeof document < "u" && new MutationObserver(O).observe(document.documentElement, L), typeof HTMLFormElement < "u" && we(), (t || typeof window < "u" && !window.CustomStateSet) && R();
      }
    }
    return !!customElements.polyfillWrapFlushCallback || (Ee() ? typeof window < "u" && !window.CustomStateSet && R(HTMLElement.prototype.attachInternals) : oe(!1)), f.forceCustomStateSetPolyfill = R, f.forceElementInternalsPolyfill = oe, Object.defineProperty(f, "__esModule", { value: !0 }), f;
  })({});
})();
var ke = Object.defineProperty, Se = Object.getOwnPropertyDescriptor, w = (f, l, c, d) => {
  for (var r = d > 1 ? void 0 : d ? Se(l, c) : l, h = f.length - 1, b; h >= 0; h--)
    (b = f[h]) && (r = (d ? b(l, c, r) : b(r)) || r);
  return d && r && ke(l, c, r), r;
};
const Te = () => function(l) {
  let c = class extends l {
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-input - emits when a standard input event would be fired
     */
    emitInput(d, r) {
      F(this, C.INPUT, !!this.onBeaconInput && this.onBeaconInput(d, r));
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-change - emits when a standard change event would be fired
     */
    emitChange(d, r) {
      F(this, C.CHANGE, !!this.onBeaconChange && this.onBeaconChange(d, r));
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-focus - emits when a beacon form component receives focus
     */
    emitFocus(d, r) {
      F(this, C.FOCUS, !!this.onBeaconFocus && this.onBeaconFocus(d, r));
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-blur - emits when a beacon form component loses focus
     */
    emitBlur(d, r) {
      F(this, C.BLUR, !!this.onBeaconBlur && this.onBeaconBlur(d, r));
    }
    /**
     * TODO: No need
     * @param event
     * @event {BeaconEvents} beacon-event-mousedown - emits when a mousedown event would be fired
     */
    emitMousedown(d) {
      F(this, C.MOUSEDOWN, !!this.onBeaconMousedown && this.onBeaconMousedown());
    }
  };
  return w([
    M({ type: Function })
  ], c.prototype, "onBeaconChange", 2), w([
    M({ type: Function })
  ], c.prototype, "onBeaconBlur", 2), w([
    M({ type: Function })
  ], c.prototype, "onBeaconInput", 2), w([
    M({ type: Function })
  ], c.prototype, "onBeaconFocus", 2), w([
    M({ type: Function })
  ], c.prototype, "onBeaconMousedown", 2), c = w([
    Fe("FormEvents")
  ], c), c;
};
var Ve = Object.defineProperty, xe = (f, l, c, d) => {
  for (var r = void 0, h = f.length - 1, b; h >= 0; h--)
    (b = f[h]) && (r = b(l, c, r) || r);
  return r && Ve(l, c, r), r;
};
class Ne extends Ce(Me, Te()) {
  static get formAssociated() {
    return !0;
  }
  constructor() {
    super(), Ie ? this.internals = null : this.internals = this.attachInternals ? this.attachInternals() : null;
  }
  /**
   * Implement `ElementInternals.setValidity()` with default values.
   * @param flags Custom validation flags.
   * @param message Error message used in validation.
   * @param anchor Validation target to receive focus, typically the form control element used in the shadow DOM.
   */
  setValidity(l, c, d = this.formAnchor) {
    this.internals && this.internals.setValidity(l, c, d);
  }
}
xe([
  Ae(".form-anchor")
], Ne.prototype, "formAnchor");
export {
  Ne as B
};
